import type { IconProps } from './icons.types';

export function ChevronDownIcon({ size = 12 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 12 7" fill="currentColor" aria-hidden="true">
      <path d="M5.65374 4.6L10.2537 -4.60609e-08L11.3075 1.05375L5.65374 6.7075L-5.76811e-06 1.05375L1.05374 -4.48206e-07L5.65374 4.6Z" />
    </svg>
  );
}
